import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TechnicalserviceService } from '../../services/technicalservice.service';
import { TechnicalserviceCompanyService } from '../../../configuration/services/technicalservice-company.service';
import { TechnicalserviceProductPieceService } from '../../services/technicalservice-product-piece.service';
import { TechnicalserviceRepairTimeService } from '../../services/technicalservice-repair-time.service';
import { InvoiceService } from '../../../common/services/invoice.service';
import { CounterService } from '../../../common/services/counter.service';
import { CounterSettings } from '../../../api.settings';
import htmlDocx from 'html-docx-js/dist/html-docx';
import * as FileSaver from 'file-saver';
import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';

import pdfMake from 'pdfmake/build/pdfmake';
import { PdfMakeWrapper,Img,Txt,Table,Cell} from 'pdfmake-wrapper';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;



declare var JSZip: any;
declare var Docxtemplater: any;
declare var JSZipUtils: any;
declare var ImageModule: any;
declare var fs: any;
declare var Buffer: any;

@Component({
  selector: 'app-view-technicalservice-repair',
  templateUrl: './view-technicalservice-repair.component.html',
  styleUrls: ['./view-technicalservice-repair.component.css'],
  providers:[TechnicalserviceService,TechnicalserviceCompanyService,TechnicalserviceProductPieceService,TechnicalserviceRepairTimeService,InvoiceService,CounterService]
})
export class ViewTechnicalserviceRepairComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  person: any = {};
  userId: number = undefined;
  technicalservice: any = {};
  technicalserviceCompanies: any = [];
  technicalServiceStatuses:any = [
    'Sin asignar',
    'Sin revisar',
    'Presupuesto aceptado',
    'Pte. de colocar piezas',
    'En proceso',
    'Pte. de aceptar presupuesto',
    'Pte. de llegada de piezas',
    'Finalizado',
    'Pte. de entregar a más con berto',
    'Pte. de recoger por el cliente',
    'Retirado por el cliente'
  ];
  technicalserviceRepairTime: any = {};
  technicalserviceRepairTimes: any = [];
  technicalserviceProductPiece: any = {};
  technicalserviceProductPieces: any = [];
  role:number = 3;
  disableIgic: Boolean = false;
  shopSerie:string = '';

  constructor(private technicalserviceService: TechnicalserviceService, private technicalserviceCompanyService:TechnicalserviceCompanyService,
              private route: ActivatedRoute, private router: Router, private technicalserviceProductPieceService:TechnicalserviceProductPieceService,
              private technicalserviceRepairTimeService:TechnicalserviceRepairTimeService, private counterService:CounterService,
              private invoiceService:InvoiceService) { }

  ngOnInit() {
    this.shopSerie = this.checkSerie(parseInt(localStorage.getItem('shop')));
    this.getTechnicalserviceCompanies();
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getTechnicalservice();
      }
    });
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;
      this.userId = JSON.parse(localStorage.getItem('user')).id;  
    }catch(e){
    }
  }

  checkSerie(shopId){
    if (shopId == 1){
      return 'M';
    }else if (shopId == 5){
      return 'T';
    }else if (shopId == 8){
      return 'C';
    }
}

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  naturalNameGuarantee(guarantee){
    let valor: string;
    if(guarantee==true){
      valor= "Si";
    }
    else{ 
      valor="No";

    }
   return valor;
  }

  getDeliveredAccessories(charger,cable,battery,mobileCase){
    let accessories ="";
    if (charger==true ){
      accessories+="Cargador,";
    }
    if(cable==true){
       accessories+="Cable,";
    }
     if(battery==true){
       accessories+="Batería,";
    }
    if(mobileCase==true){
       accessories+="Funda,";
    }
    if(accessories===""){
      accessories='No entrega ningún accesorio,';
    }
    accessories=accessories.substring(0,accessories.length-1);
    return accessories;
    
  }


  calculateTotalTime(){
    if (this.technicalserviceRepairTime.init_time && this.technicalserviceRepairTime.finish_time){
      let init = moment(this.technicalserviceRepairTime.init_time, 'HH:mm');
      let finish = moment(this.technicalserviceRepairTime.finish_time, 'HH:mm');
      let tempTime = moment.duration(finish.diff(init));
      this.technicalserviceRepairTime.total_time = tempTime.hours() +":"+ (tempTime.minutes() <10? '0'+tempTime.minutes():tempTime.minutes());
    }
     
  }
  calculateTotalCostPrice(){
    if (this.technicalserviceProductPiece.cost_price != undefined){
      this.technicalserviceProductPiece.quantity = this.technicalserviceProductPiece.quantity? this.technicalserviceProductPiece.quantity:1;
      this.technicalserviceProductPiece.total_cost_price = this.roundValue(this.technicalserviceProductPiece.quantity * this.technicalserviceProductPiece.cost_price);
    }
  }
  roundValue(value){
    return Math.round(value * 100) / 100;
  }

  getTechnicalserviceCompanies(){
    this.technicalserviceCompanyService.query({}).subscribe((technicalserviceCompanies)=>{
      this.technicalserviceCompanies = technicalserviceCompanies;
    });
  }

  getTechnicalservice(){
    this.technicalserviceService.get(this.id).subscribe((technicalservice) => {
      technicalservice.date = this.getDate(technicalservice.date);
      technicalservice.delivery_date_tsc = this.getDate(technicalservice.delivery_date_tsc);
      technicalservice.repair_date = this.getDate(technicalservice.repair_date);
      technicalservice.purchase_date = this.getDate(technicalservice.purchase_date);
      this.technicalservice = technicalservice;
      this.person = technicalservice.person;
      if(this.technicalservice.technicalserviceCompany){
        this.technicalservice.technicalserviceCompany = this.technicalservice.technicalserviceCompany.name;
      }
      this.getTechnicalserviceRepairTime();
      this.getTechnicalserviceProductPieces();
      this.calculateTotalAmounts();
     
      if(this.technicalservice.enter_by=="Nueva entrada"){
        this.technicalservice.entry='',
        this.technicalservice.entry +=this.technicalservice.enter_by ;

      }
      if(this.technicalservice.enter_by=="Garantía de reparación"){
        this.technicalservice.entry='',
      this.technicalservice.entry +=this.technicalservice.enter_by +','+'Fecha de Compra:'+moment(this.technicalservice.purchase_date).format("DD-MM-YYYY")

      }
      if(this.technicalservice.enter_by=="Garantía de compra"){
        this.technicalservice.entry='',
        this.technicalservice.entry +=this.technicalservice.enter_by +','+'Fecha de Compra:'+moment(this.technicalservice.purchase_date).format("DD-MM-YYYY")
      }
    });
  }

  getTechnicalserviceRepairTime(){
    let params ={
      technicalservice: this.id
    }
    this.technicalserviceRepairTimeService.query(params).subscribe((technicalserviceRepairTimes) => {
      this.technicalserviceRepairTimes = technicalserviceRepairTimes;
      technicalserviceRepairTimes.forEach(technicalserviceRepairTime =>{
         technicalserviceRepairTime.date=moment(technicalserviceRepairTime.date).format('DD-MM-YYYY');
         
       /* this.technicalservice.totalHours= moment(this.technicalservice.totalHours).format("HH:mm")*/
       /* this.technicalservice.totalHours += technicalserviceRepairTime.total_time;*/
      }); 
    });
  } 
  saveTechnicalserviceRepairTime(){
    this.technicalserviceRepairTime.technicalservice_id = this.id;
    this.technicalserviceRepairTimeService.create(this.technicalserviceRepairTime)
      .subscribe((technicalserviceRepairTime) => {
        this.technicalserviceRepairTime = {};
        this.getTechnicalserviceRepairTime();
        if (this.technicalservice.status == 'Sin revisar'){
          this.changeStatus("En proceso");
        }
    });
  }

  deleteTechnicalserviceRepairTime(technicalserviceRepairTime){
    this.technicalserviceRepairTimeService.delete(technicalserviceRepairTime.id)
      .subscribe((technicalserviceRepairTime) => {
         alert("¿Esta seguro que quiere eliminar esta pieza?")
        this.getTechnicalserviceRepairTime();
    });
  }

  getTechnicalserviceProductPieces(){
    let params ={
      technicalservice: this.id
    }
    this.technicalserviceProductPieceService.query(params).subscribe((technicalserviceProductPieces) => {
      this.technicalserviceProductPieces = technicalserviceProductPieces;
      this.technicalservice.totalCostPieces = 0;
      technicalserviceProductPieces.forEach(technicalserviceProductPiece =>{ 
        if(technicalserviceProductPiece.description == undefined ){
          technicalserviceProductPiece.description=''
        }
        this.technicalservice.totalCostPieces += technicalserviceProductPiece.total_cost_price;
      });
      this.calculateTotalAmounts();
    });
  }

  saveTechnicalserviceProductPieces(){
    this.technicalserviceProductPiece.technicalservice_id = this.id;
    this.technicalserviceProductPieceService.create(this.technicalserviceProductPiece)
      .subscribe((technicalserviceProductPiece) => {
        this.technicalserviceProductPiece = {};
        this.getTechnicalserviceProductPieces();
        if (this.technicalservice.status == 'Sin revisar'){
          this.changeStatus("En proceso");
        }
    });
  }

  deleteTechnicalserviceProductPieces(technicalserviceProductPiece){
    this.technicalserviceProductPieceService.delete(technicalserviceProductPiece.id)
    .subscribe(() => {
      alert("¿Esta seguro que quiere eliminar este proceso de trabajo?")
      this.getTechnicalserviceProductPieces();
    });
  }

  calculateTechnicalServiceOrder(status){
    return _.findIndex(this.technicalServiceStatuses,(s)=>{return s == status});
  }

  changeStatus(status){
    var technicalservice:any = {
      id: this.technicalservice.id,
      status: status,
      status_order: this.calculateTechnicalServiceOrder(status)
    }
    if (status === "Retirado por el cliente"){
      technicalservice.withdrawal_date = new Date();
      technicalservice.withdrawal_by = this.userId;
      technicalservice.withdrawal_shop = localStorage.getItem('shop');
      technicalservice.net_total = this.technicalservice.netTotal;
    }
    this.technicalserviceService.update(technicalservice)
      .subscribe((technicalservice) => {
        this.getTechnicalservice();
      });
  }

  getDate(date){
    if (date){
      date = new Date(date);
      let month = (date.getMonth()+1) < 10? '0'+(date.getMonth()+1):(date.getMonth()+1);
      let day = date.getDate() < 10? '0'+date.getDate():date.getDate();
      return date.getFullYear() + "-" + month + '-' + day;
    }else{
      return null;
    }
  }

  getDateForFooter(date){
    let dateObj=moment(date);
    let month=dateObj.lang("es").format('MMMM');
    let hour = dateObj.format('HH:mm');
    let day = dateObj.format('DD');
    let year = dateObj.format('YYYY');
    let dateResult = day+ " de " + month + " de " + year+',' +  " a las "+ hour + " horas. ";

    return dateResult;  
  }

  saveTechnicalservice(){
    return new Promise((resolve, reject) => {
      this.technicalserviceService.update(this.returnTechnicalserviceProperties(this.technicalservice))
      .subscribe((technicalservice) => {
        this.technicalservice = technicalservice;
        this.id = technicalservice.id;
        this.getTechnicalservice();
        resolve();
      });
    });
  }

  calculateTotalAmounts(){
    this.technicalservice.taxBase = 0;
    if (this.technicalservice.totalCostPieces){
      this.technicalservice.taxBase += parseFloat(this.technicalservice.totalCostPieces);
    }
    if (this.technicalservice.workshop_out){
      this.technicalservice.taxBase += parseFloat(this.technicalservice.workshop_out);
    }
    if(this.technicalservice.displacement){
      this.technicalservice.taxBase += parseFloat(this.technicalservice.displacement);
    }
    if(this.technicalservice.workforce){
      this.technicalservice.taxBase += parseFloat(this.technicalservice.workforce);
    }
    this.technicalservice.taxBase = this.roundValue(this.technicalservice.taxBase);
    this.technicalservice.igic = !this.technicalservice.disable_igic?this.roundValue(this.technicalservice.taxBase*0.07):0;
    this.technicalservice.netTotal = this.roundValue(this.technicalservice.taxBase+this.technicalservice.igic);
    this.technicalservice.total = this.roundValue(this.technicalservice.totalCostPieces+this.technicalservice.workforce);
  }

  returnTechnicalserviceProperties(technicalservice){
    var properties = {
      work_done: technicalservice.work_done,
      workshop_out: technicalservice.workshop_out,
      displacement: technicalservice.displacement,
      workforce: technicalservice.workforce,
      disable_igic: technicalservice.disable_igic,
      method_of_payment: technicalservice.method_of_payment,
      net_total: technicalservice.netTotal
    }
    if (technicalservice.id){
      properties['id'] = technicalservice.id;
    }
    return properties;
  }



  loadFile(url,callback){
    JSZipUtils.getBinaryContent(url,callback);
    
  }
  checkCounterNumber(counterName, year){
    return new Promise((resolve, reject) => {
        let params = {
            where: {
                name:counterName, 
                year: year
            }
        }
        this.counterService.query(params).subscribe((result) => {
            result = result[0];
            if (result === undefined){
                this.counterService.create({name:counterName,year: year,counter:1}).subscribe(() => {
                    resolve(1)
                });
            }else{
                this.counterService.update({id:result.id,counter:result.counter + 1}).subscribe(() => {
                    resolve(result.counter + 1)
                });
            }
        });
    });
  }

  generateInvoice(){
    if (this.technicalservice.invoice && this.technicalservice.invoice.id){
      this.invoiceService.get(this.technicalservice.invoice.id).subscribe((invoice)=>{
        this.generateInvoicePDF(invoice);
        //this.downloadInvoice(invoice);           
      }); 
    }else{
        this.checkCounterNumber(this.checkSerie(this.technicalservice.shop.id)+"_"+CounterSettings.TECHNICALSERVICE_INVOICE_COUNTER_LABEL, moment().year()).then((counter:number) =>{
            let invoice = {
                number: counter,
                serie: this.checkSerie(this.technicalservice.shop.id)+'R',
                date: new Date(),
                customer_name: this.technicalservice.person.name != undefined? this.technicalservice.person.name: '',  
                customer_nif: this.technicalservice.person.nif != undefined? this.technicalservice.person.nif:'',
                customer_address: this.technicalservice.person.address != undefined? this.technicalservice.person.address:'',
                customer_cp: this.technicalservice.person.cp != undefined? this.technicalservice.person.cp:'',
                customer_state: this.technicalservice.person.state != undefined? this.technicalservice.person.state:'',
                customer_phone1: this.technicalservice.person.telephone !=undefined? this.technicalservice.person.telephone:'',
                customer_phone2: this.technicalservice.person.mobile != undefined? this.technicalservice.person.mobile:'',
                tax: 7,
                tax_amount: this.technicalservice.igic != undefined? this.technicalservice.igic:'',
                total_amount: this.technicalservice.netTotal != undefined? this.technicalservice.netTotal:'',
            }
            
            this.invoiceService.create(invoice).subscribe((invoice)=>{
                this.technicalserviceService.update({id:this.technicalservice.id, invoice_id: invoice.id}).subscribe(()=>{
                  this.generateInvoicePDF(invoice);
                  this.getTechnicalservice();
                  //this.downloadInvoice(invoice); 
                });
            });
        });
    }
  }

  downloadInvoice(invoice){
      var opts = {
        centered : false,
        getImage: function(image){
          return image;
        },
      
        getSize: function(img,tagValue, tagName) {
          return [150,150];
        }
      }
      var imageModule=new ImageModule(opts);
      var _this = this;
      this.loadFile("assets/TecnicalServiceBill_template.docx",function(error,content){
        if (error) { throw error };
        var zip = new JSZip(content);
        var doc=new Docxtemplater()
                .attachModule(imageModule)
                .loadZip(zip)  
        var P = [];
        _this.technicalserviceProductPieces.forEach(function (technicalserviceProductPiece){
          P.push(technicalserviceProductPiece)
        })  
        doc.setData({
        newdate:_this.getDateForFooter(invoice.date),
        P:P, 
        serie:invoice.serie,
        num:invoice.number,
        workshop:_this.technicalservice.workshop_out != undefined? _this.technicalservice.workshop_out: '',
        displacement:_this.technicalservice.displacement != undefined? _this.technicalservice.displacement: '',
        workforce:_this.technicalservice.workforce != undefined? _this.technicalservice.workforce: '',
        taxbase:_this.technicalservice.taxBase != undefined? _this.technicalservice.taxBase : '',
        tax:invoice.tax,
        igic:invoice.tax_amount,
        nettotal:invoice.total_amount,
        payment:_this.technicalservice.method_of_payment,
        T: [ 
              {
              state:invoice.customer_state,
              town:_this.technicalservice.person.town != undefined? _this.technicalservice.person.town: '',
              address:invoice.customer_address,
              cp:invoice.customer_cp,
              NIF:invoice.customer_nif,
              first_name: invoice.customer_name,
              telephone1:invoice.customer_phone1,
              telephone2:invoice.customer_phone2,
              purchase_date:_this.technicalservice.purchase_date?moment(_this.technicalservice.purchase_date).format("DD-MM-YYYY"):'',
              guarantee:_this.naturalNameGuarantee(_this.technicalservice.guarantee),
              description:_this.technicalservice.problems  != undefined? _this.technicalservice.problems : '',
              article:_this.technicalservice.product != undefined? _this.technicalservice.product : '',
              work_done:_this.technicalservice.work_done != undefined? _this.technicalservice.work_done: '',
              description_Piece:_this.technicalserviceProductPiece.description != undefined?  _this.technicalserviceProductPiece:' ',
              TotalCostPieces:_this.technicalservice.totalCostPieces != undefined?  _this.technicalservice.totalCostPieces:' ',
              accessories:_this.getDeliveredAccessories(_this.technicalservice.charger,_this.technicalservice.cable,_this.technicalservice.battery,_this.technicalservice.case),
              entry:_this.technicalservice.entry  != undefined? _this.technicalservice.entry: '',
              part:_this.technicalservice.id  != undefined? _this.technicalservice.id: '',    
              } 
            ]
                      
            });
            
        try {
            // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
            doc.render()
        }
        catch (error) {
            var e = {
                message: error.message,
                name: error.name,
                stack: error.stack,
                properties: error.properties,
            }
            console.log(JSON.stringify({error: e}));
            // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
            throw error;
        }

        var out=doc.getZip().generate({
            type:"blob",
            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        }) //Output the document using Data-URI
        //saveAs(out,"output.docx")
        FileSaver.saveAs(out, 'FacturaServicioTécnico.docx');    
        _this.changeStatus("Retirado por el cliente");
    })
  }

  saveIfRequiredAndExecute(type){
    if (this.technicalservice.invoice && this.technicalservice.invoice.id){
      if (type === 1){
        this.downloadPart();
      }else{
        this.generateInvoice();
      }
    }else{
      this.saveTechnicalservice().then(()=>{
        if (type === 1){
          this.downloadPart();
        }else{
          this.generateInvoice();
        }
      });
    }
  }

  generateInvoicePDF(invoice) { 
    invoice.phone = invoice.customer_phone1 + ', ' + invoice.customer_phone2;
    invoice.number_pdf = invoice.serie + invoice.number;
    invoice.totalPDF = "IMPORTE TOTAL: " + invoice.total_amount +'€';
    invoice.totalPieces = "Total Costo Piezas: " + this.technicalservice.totalCostPieces + '€';
    invoice.totalPDF =  'Salida del taller: '+ (this.technicalservice.workshop_out?this.technicalservice.workshop_out:"") + '€' + '\n' + 'Desplazamiento: ' + (this.technicalservice.displacement?this.technicalservice.displacement:"") + '€'+ '\n' + 'Mano de Obra: ' + (this.technicalservice.workforce?this.technicalservice.workforce:"") + '€' + '\n' +'Base Imponible: ' + (this.technicalservice.taxBase?this.technicalservice.taxBase:"") + '€'+ '\n'+ 'I.G.I.C ' + (invoice.tax?invoice.tax:"") + '%: ' + (invoice.tax_amount?invoice.tax_amount:"") + '€'+ '\n'+ 'TOTAL NETO: ' + (invoice.total_amount?invoice.total_amount:"") + '€'+ '\n';
    invoice.datos = 'Artículo: ' + (this.technicalservice.product?this.technicalservice.product:"") + '\n' + 'Entrada por: ' + (this.technicalservice.entry?this.technicalservice.entry:"") + '\n' + 'Accesorios entregados: ' + this.getDeliveredAccessories(this.technicalservice.charger,this.technicalservice.cable,this.technicalservice.battery,this.technicalservice.case) + '\n'+ 'Descripción de la avería: ' + (this.technicalservice.problems?this.technicalservice.problems:"") + '\n' + 'Trabajos realizados: ' + (this.technicalservice.work_done?this.technicalservice.work_done:"");
    invoice.totalBill = 'IMPORTE TOTAL: ' + invoice.total_amount + '€';
    invoice.IGIC = invoice.tax + '%';
    var P = [];
    this.technicalserviceProductPieces.forEach(function (technicalserviceProductPiece){
      P.push(technicalserviceProductPiece)
    }) 
    const pdf = new PdfMakeWrapper();      
    new Img('https://app.masconberto.com/assets/img/logomasconberto.png').build().then(img => {
    pdf.add(img);
    pdf.add(new Table([
      [ 'ALBERTO H. RODRIGUEZ DELGADO',invoice.customer_name],
      [ '43.796.214-M',invoice.customer_nif],
      [ 'CL SAN FRANCISCO JAVIER 24',invoice.customer_address],
      [ '38001 STA CRUZ DE TENERIFE',invoice.customer_cp ],
      [ 'Tel. 822 04 16 50 - 657 06 11 00',invoice.phone],
      [ 'tienda@masconberto.com',invoice.customer_state]]).fontSize(10).widths(['65%', '35%']).margin([5,10,0,10]).layout('noBorders').end)
    pdf.add(new Txt('FACTURA').bold().fontSize(25).margin([5,10,0,10]).end)
    pdf.add(new Table([
      ['Factura Nº:','Fecha:','Parte Nº:','Forma de pago:']]).fontSize(10).widths(['25%', '35%','20%','20%']).margin([5,0,0,0]).layout('noBorders').end)
    pdf.add(new Table([
      [(new Txt(invoice.number_pdf).end),(new Txt(moment(invoice.date).format("DD-MM-YYYY")).end),this.technicalservice.id,this.technicalservice.method_of_payment]]).layout('noBorders').widths(['25%', '35%','20%','20%']).margin([5,0,0,5]).end)
    pdf.add(new Txt(invoice.datos).margin([5,0,0,5]).fontSize(10).end)
    pdf.add(new Table([[
      new Txt('Referencia').bold().alignment('center').end,
      new Txt('Descripción').bold().end,
      new Txt('Unidades').bold().end,
      new Txt('Precio Ud.').bold().end,
      new Txt('Total').bold().end]]).fontSize(10).alignment('center').widths(['15%', '40%','10%','10%','25%']).margin([0,10,0,0]).end)
    for(let i=0; i<P.length;i++){ 
      pdf.add(
        new Table([[P[i].reference,new Txt(P[i].description).alignment('left').end,P[i].quantity,P[i].cost_price,new Txt(P[i].total_cost_price).alignment('right').end]]).widths(['15%', '40%','10%','10%','25%']).alignment('center').end);     
    }   
    pdf.add(new Table([
      [' ','','','',new Txt(invoice.totalPieces).end]]).widths(['15%', '40%','10%','5%','30%']).fontSize(11).margin([0,5,0,0]).alignment('right').bold().layout('noBorders').end)           

   pdf.add(new Table([
      [new Txt('Salida del taller').end,new Txt('Desplazamiento').end,new Txt('Mano de Obra').end,new Txt('Base Imponible').end,new Txt('I.G.I.C').end]
    ]).widths(['20%','20%','20%','20%','20%']).fontSize(10).bold().alignment('center').margin([0,10,0,0]).end)

    pdf.add(new Table([
      [(this.technicalservice.workshop_out?this.technicalservice.workshop_out:""),this.technicalservice.displacement?this.technicalservice.displacement:"",
      this.technicalservice.workforce?this.technicalservice.workforce:"",this.technicalservice.taxBase?this.technicalservice.taxBase:"",invoice.IGIC]
    ]).widths(['20%','20%','20%','20%','20%']).alignment('center').end)

    pdf.add(new Table([
      ['','','','',invoice.totalBill]
    ]).widths(['20%','20%','20%','10%','30%']).layout('noBorders').alignment('right').bold().margin([0,10,0,0]).end)

    pdf.footer(new Txt ('Las reparaciones reflejadas en la presente factura, incluidos los gastos de mano de obra, contarán con una garantía de 3 meses (excepto los artículos mojados), a partir de la fecha de entrega del objeto a reparar.').bold().fontSize(10).margin([15,5,15,5]).end); 
    pdf.create().open();         
    });  
}

  downloadPart(){
      var opts = {
        centered : false,
        // getImage :function(tagValue, tagName) {
        //   try {
        //     var fileContents = fs.readFileSync(tagValue);
        //   } catch (err) {
        //     console.log(err);
        //     // Here you get the error when the file was not found,
        //     // but you also get any other error
        //   }
        //   console.log(fs.readFileSync(tagValue))
        //   return fs.readFileSync(tagValue);
        // },
        getImage: function(image){
          return image;
        },
      
        getSize: function(img,tagValue, tagName) {
          return [150,150];
        }

      }
      var imageModule=new ImageModule(opts);
      var _this = this;
      this.loadFile("assets/TecnicalServicePart_template.docx",function(error,content){
        if (error) { throw error };
        var zip = new JSZip(content);
        var doc=new Docxtemplater()
                .attachModule(imageModule)
                .loadZip(zip) 
        var tech = [];
        _this.technicalserviceRepairTimes.forEach(function (technicalserviceRepairTime){
          tech.push(technicalserviceRepairTime)
          })
        var products = [];
        _this.technicalserviceProductPieces.forEach(function (technicalserviceProductPiece){
          products.push(technicalserviceProductPiece)
        }) 
        var C = [];
        _this.technicalserviceCompanies.forEach(function (technicalserviceCompany){
          C.push(technicalserviceCompany)
        }) 


        
      doc.setData({
      tech:tech,
      products:products,
      C:C,
      newdate:_this.getDateForFooter(new Date()),
      number:_this.technicalservice.id != undefined? _this.technicalservice.id: '',
      T: [ 
              {
              first_name: _this.technicalservice.person.name != undefined? _this.technicalservice.person.name+' '+_this.technicalservice.person.surname: '',
              telephone1:_this.technicalservice.person.telephone != undefined? _this.technicalservice.person.telephone: '',
              telephone2:_this.technicalservice.person.mobile != undefined? _this.technicalservice.person.mobile: '',
              date:_this.technicalservice.date?moment(_this.technicalservice.date).format("DD-MM-YYYY"):'',
              guarantee:_this.naturalNameGuarantee(_this.technicalservice.guarantee),
              description:_this.technicalservice.problems != undefined? _this.technicalservice.problems: '',
              email:_this.technicalservice.person.email != undefined? _this.technicalservice.person.email: '',
              article:_this.technicalservice.product != undefined? _this.technicalservice.product: '',
              accessories:_this.getDeliveredAccessories(_this.technicalservice.charger,_this.technicalservice.cable,_this.technicalservice.battery,_this.technicalservice.case),
              entry:_this.technicalservice.entry  != undefined? _this.technicalservice.entry: '',
              work:_this.technicalservice.work_done != undefined? _this.technicalservice.work_done: '',
              work_force:_this.technicalservice.workforce != undefined? _this.technicalservice.workforce: '',
              tsc:_this.technicalservice.delivery_date_tsc?moment(_this.technicalservice.delivery_date_tsc).format("DD-MM-YYYY"):'',
              TotalCostPiece:_this.technicalservice.totalCostPieces != undefined? _this.technicalservice.totalCostPieces: '',
              purchase_date:_this.technicalservice.purchase_date?moment(_this.technicalservice.purchase_date).format("DD-MM-YYYY"):'',
              part:_this.technicalservice.id  != undefined? _this.technicalservice.id: '',
              tecnic:_this.technicalservice.technicalserviceCompany != undefined? _this.technicalservice.technicalserviceCompany: '',
              Piece_force:_this.technicalservice.total != undefined? _this.technicalservice.total: '',
              } 
                        ]
            });
            
        try {
            // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
            doc.render()
        }
        catch (error) {
            var e = {
                message: error.message,
                name: error.name,
                stack: error.stack,
                properties: error.properties,
            }
            console.log(JSON.stringify({error: e}));
            // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
            throw error;
        }

        var out=doc.getZip().generate({
            type:"blob",
            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        }) //Output the document using Data-URI
        //saveAs(out,"output.docx")
        FileSaver.saveAs(out, 'ParteServicioTécnico.docx');    
    })

  }
}



// WEBPACK FOOTER //
// ./src/app/technicalservice/components/view-technicalservice-repair/view-technicalservice-repair.component.ts